import type { GeomTypeUtil } from "./geomTypeUtil";
import type BoundsUtil from "../../boundsUtil";
import type MatrixUtil from "../../matrixUtil";
import type GeomUtil from "../geomUtil";

/**
 * Geometry functions for polygon
 */
export default class PN implements GeomTypeUtil {
    private boundsUtil: BoundsUtil;
    private geomUtil: GeomUtil;
    private matrixUtil: MatrixUtil;

    constructor(boundsUtil: BoundsUtil, geomUtil: GeomUtil, matrixUtil: MatrixUtil) {
        this.boundsUtil = boundsUtil;
        this.geomUtil = geomUtil;
        this.matrixUtil = matrixUtil;
    }

    /**
     * 
     * @param geom 
     * @param callback 
     * @param owner 
     */
    extractPoints(geom: any[], callback: Function, owner?: any) {
        for (let g = geom.length; g-- > 1; ) {
            const ring = geom[g];
            
            for (let r = ring.length - 2; r >= 2; r -= 2) {
                callback.call(owner, ring, r);
            }
        }
    }

    /**
     * 
     * @param geom 
     * @param callback 
     * 
     * @param owner 
     */
    extractMidPoints(geom: any[], callback: Function, owner?: any) {
        this.extractLines(geom, (array: number[], startIndex: number, endIndex: number, ringIndex: number) => {
            while (startIndex < endIndex - 2) { // last point is the same as the first point in polygon
                const midPointStartIndex = startIndex;
                const x1 = array[startIndex++];
                const y1 = array[startIndex++];
                const x2 = array[startIndex];
                const y2 = array[startIndex + 1];
                const midPoint = [(x1 + x2) / 2, (y1 + y2) / 2];

                callback.call(owner, midPoint, midPointStartIndex, ringIndex);
            }
        });
    }

    /**
     * 
     * @param geom 
     * @param callback 
     * @param owner 
     */
    extractLines(geom: any[], callback: Function, owner?: any) {
        for (let g = geom.length; g-- > 1; ) {
            const ring = geom[g];

            callback.call(owner, ring, 0, ring.length, g);
        }
    }

    /**
     * 
     * @param geom 
     * @param bounds 
     * 
     * @returns 
     */
    getBounds(geom: any[], bounds: number[]): number[] {
        for (let g = 1; g < geom.length; g++) {
            bounds = this.boundsUtil.valueOf(geom[g], bounds);
        }

        return bounds;
    }

    /**
     * 
     * @param geom 
     * @param matrix 
     * 
     * @returns 
     */
    transform(geom: any[], matrix: any[]): any[] {
        const ret: any[] = ["PN"];
        for (let g = 1; g < geom.length; g++) {
            const ring = geom[g];

            ret[g] = this.matrixUtil.transform(matrix, ring, 0, ring.length);
        }

        return ret;
    }

    /**
     * 
     * @param geom 
     * @param threshold 
     * 
     * @returns 
     */
    generalize(geom: any[], threshold: number): any[] {
        const ret: any[] = ["PN"];
        for (let g = 1; g < geom.length; g++) {
            const ring = geom[g];

            ret.push(this.geomUtil.generalizeLines(ring, 0, null, threshold));
        }

        return ret;
    }
}
